<div class="wrapper">
  <div class="title-bar">
    <h1>Admin Portal</h1>
  </div>
  @if (auth.user | async; as user) {
    <div>
      @if (user.admin) {
        <div class="school-toolbar">
          <div class="school-search">
            <mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Fast Navigate</mat-label>
              <input type="search" matInput placeholder="Search by name or code" autocomplete="off" [formControl]="schoolSearchControl" [matAutocomplete]="schoolAuto" aria-label="Search for a school to navigate to" />
              <mat-autocomplete #schoolAuto="matAutocomplete" [displayWith]="displaySchool.bind(this)" (optionSelected)="onSchoolSelected($event)">
                @for (school of filteredSchools | async; track school.id) {
                  <mat-option [value]="school" [disabled]="isSchoolDeactivated(school)">
                    {{ school.name }} ({{ school.id }})
                    @if (isSchoolDeactivated(school)) {
                      — Deactivated
                    }
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <a mat-flat-button color="primary" routerLink="/schools/new">Create school</a>
        </div>

        <div>
          <mat-tab-group mat-stretch-tabs="false">
            @if (sa.liveSchools | async; as liveSchools) {
              <div>
                <mat-tab [label]="'Live Schools (' + liveSchools.length + ')'">
                  <div class="table-container">
                    <table matSort matSortDisableClear="true" (matSortChange)="sa.sortSchools($event, liveSchools)" class="table table-sm table-hover" style="width: auto">
                      <thead>
                        <th mat-sort-header="name">School</th>
                        <th mat-sort-header="method">Method</th>
                        <th mat-sort-header="live">Live since</th>
                        <th mat-sort-header="lastLogIn">Last Log In</th>
                        <th mat-sort-header="lastPublished">Last Published</th>
                        <th mat-sort-header="aidYear">Aid Year</th>
                        <th mat-sort-header="visitors">Visitors</th>
                        <th mat-sort-header="results">Results</th>
                      </thead>
                      @for (school of liveSchools; track school) {
                        <tr>
                          <td>
                            <a [routerLink]="['../' + school.id + '/dashboard']">{{ school.name }}</a>
                          </td>
                          <td>{{ school.schoolProperties?.institutionalMethod ? "IM" : "" }}</td>
                          <td>{{ !school.live ? "" : (school.live | dateAgo) }}</td>
                          <td>{{ !school.lastLogIn ? "" : (school.lastLogIn | dateAgo) }}</td>
                          <td>{{ !school.lastPublished ? "" : (school.lastPublished | dateAgo) }}</td>
                          <td>
                            @if (school.schoolProperties?.draftAidYear; as draftAidYear) {
                              <span style="color: darkred">{{ draftAidYear !== school.schoolProperties?.aidYear ? "[" + draftAidYear + "]" : "" }}</span>
                            }
                            {{ school.schoolProperties?.aidYear }}
                          </td>
                          <td>{{ school.latestTraffic?.visitors }}</td>
                          <td>{{ school.latestTraffic?.results }}</td>
                        </tr>
                      }
                    </table>
                    <button mat-button (click)="getCodes(liveSchools)">get codes</button>
                  </div>
                </mat-tab>
              </div>
            }
            @if (sa.demoSchools | async; as demoSchools) {
              <div>
                <mat-tab [label]="'Demo Schools (' + demoSchools.length + ')'">
                  <div class="table-container">
                    <table matSort matSortDisableClear="true" (matSortChange)="sa.sortSchools($event, demoSchools)" class="table table-sm table-hover" style="width: auto">
                      <thead>
                        <th mat-sort-header="name">School</th>
                        <th mat-sort-header="method">Method</th>
                        <th mat-sort-header="lastLogIn">Last Log In</th>
                        <th mat-sort-header="lastPublished">Last Published</th>
                        <th mat-sort-header="aidYear">Aid Year</th>
                      </thead>
                      @for (school of demoSchools; track school) {
                        <tr>
                          <td>
                            <a [routerLink]="['../' + school.id + '/dashboard']">{{ school.name }}</a>
                          </td>
                          <td>{{ school.schoolProperties?.institutionalMethod ? "IM" : "" }}</td>
                          <td>{{ !school.lastLogIn ? "" : (school.lastLogIn | dateAgo) }}</td>
                          <td>{{ !school.lastPublished ? "" : (school.lastPublished | dateAgo) }}</td>
                          <td>
                            @if (school.schoolProperties?.draftAidYear; as draftAidYear) {
                              <span style="color: darkred">{{ draftAidYear !== school.schoolProperties?.aidYear ? "[" + draftAidYear + "]" : "" }}</span>
                            }
                            {{ school.schoolProperties?.aidYear }}
                          </td>
                        </tr>
                      }
                    </table>
                    <button mat-button (click)="getCodes(demoSchools)">get codes</button>
                  </div>
                </mat-tab>
              </div>
            }
            @if (sa.comingSchools | async; as comingSchools) {
              <div>
                <mat-tab [label]="'Coming Soon (' + comingSchools.length + ')'">
                  <div class="table-container">
                    <table matSort matSortDisableClear="true" (matSortChange)="sa.sortSchools($event, comingSchools)" class="table table-sm table-hover" style="width: auto">
                      <thead>
                        <th mat-sort-header="name">School</th>
                        <th mat-sort-header="method">Method</th>
                        <th mat-sort-header="lastLogIn">Last Log In</th>
                        <th mat-sort-header="lastPublished">Last Published</th>
                        <th mat-sort-header="aidYear">Aid Year</th>
                      </thead>
                      @for (school of comingSchools; track school) {
                        <tr>
                          <td>
                            <a [routerLink]="['../' + school.id + '/dashboard']">{{ school.name }}</a>
                          </td>
                          <td>{{ school.schoolProperties?.institutionalMethod ? "IM" : "" }}</td>
                          <td>{{ !school.lastLogIn ? "" : (school.lastLogIn | dateAgo) }}</td>
                          <td>{{ !school.lastPublished ? "" : (school.lastPublished | dateAgo) }}</td>
                          <td>{{ school.schoolProperties?.aidYear }}</td>
                        </tr>
                      }
                    </table>
                    <button mat-button (click)="getCodes(comingSchools)">get codes</button>
                  </div>
                </mat-tab>
              </div>
            }
            @if (sa.pausedSchools | async; as pausedSchools) {
              <div>
                <mat-tab [label]="'Paused Schools (' + pausedSchools.length + ')'">
                  <div class="table-container">
                    <table matSort matSortDisableClear="true" (matSortChange)="sa.sortSchools($event, pausedSchools)" class="table table-sm table-hover" style="width: auto">
                      <thead>
                        <th mat-sort-header="name">School</th>
                        <th mat-sort-header="method">Method</th>
                        <th mat-sort-header="disabledDate">Disabled since</th>
                        <th mat-sort-header="lastLogIn">Last Log In</th>
                        <th mat-sort-header="lastPublished">Last Published</th>
                        <th mat-sort-header="aidYear">Aid Year</th>
                      </thead>
                      @for (school of pausedSchools; track school) {
                        <tr>
                          <td>
                            <a [routerLink]="['../' + school.id + '/dashboard']">{{ school.name }}</a>
                          </td>
                          <td>{{ school.schoolProperties?.institutionalMethod ? "IM" : "" }}</td>
                          <td>{{ !school.disabledDate ? "" : (school.disabledDate | dateAgo) }}</td>
                          <td>{{ !school.lastLogIn ? "" : (school.lastLogIn | dateAgo) }}</td>
                          <td>{{ !school.lastPublished ? "" : (school.lastPublished | dateAgo) }}</td>
                          <td>{{ school.schoolProperties?.aidYear }}</td>
                        </tr>
                      }
                    </table>
                    <button mat-button (click)="getCodes(pausedSchools)">get codes</button>
                  </div>
                </mat-tab>
              </div>
            }
            @if (sa.notActiveSchools | async; as disabledSchools) {
              <div>
                <mat-tab [label]="'Deactivated Schools (' + disabledSchools.length + ')'">
                  <div class="table-container">
                    <table matSort matSortDisableClear="true" (matSortChange)="sa.sortSchools($event, disabledSchools)" class="table table-sm table-hover" style="width: auto">
                      <thead>
                        <th mat-sort-header="name">School</th>
                        <th mat-sort-header="method">Method</th>
                        <th mat-sort-header="disabledDate">Disabled since</th>
                        <th mat-sort-header="lastLogIn">Last Log In</th>
                        <th mat-sort-header="lastPublished">Last Published</th>
                      </thead>
                      @for (school of disabledSchools; track school) {
                        <tr>
                          <td>
                            <a [routerLink]="['../' + school.id + '/dashboard']">{{ school.name }}</a>
                          </td>
                          <td>{{ school.schoolProperties?.institutionalMethod ? "IM" : "" }}</td>
                          <td>{{ !school.disabledDate ? "" : (school.disabledDate | dateAgo) }}</td>
                          <td>{{ !school.lastLogIn ? "" : (school.lastLogIn | dateAgo) }}</td>
                          <td>{{ !school.lastPublished ? "" : (school.lastPublished | dateAgo) }}</td>
                        </tr>
                      }
                    </table>
                    <button mat-button (click)="getCodes(disabledSchools)">get codes</button>
                  </div>
                </mat-tab>
              </div>
            }
          </mat-tab-group>
          <p></p>
        </div>
      }
      <!-- Not a Super Admin -->
      @if (!user.admin) {
        <div>
          @if (userSchools | async; as schools) {
            <div>
              @if (schools.length === 0) {
                <div>
                  <br />
                  <h1 style="padding-left: 20px">Awaiting access...</h1>
                  <p style="padding-left: 20px">Please wait for the net price calculator admin staff to authorize your account. Thank you for your patience.</p>
                  <p style="padding-left: 20px">In a hurry? Call use Toll Free <a href="tel:8006573013">(800)657-3013</a> or send us an email at <a href="mailto:npc_support@rewiretech.com">npc_support&#64;rewiretech.com</a></p>
                </div>
              }
              @if (schools.length > 0) {
                <div>
                  <p>Welcome! You have access to multiple schools. Click on your school below to try the options setting.</p>
                  <h2>Available Schools</h2>
                  @for (schoolId of userSchools | async; track schoolId) {
                    <div>
                      <a [routerLink]="['../' + schoolId + '/dashboard']">{{ schoolId }}</a>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  } @else {
    Loading stuff...
  }
</div>
